import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import moment from "moment"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        max-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding-top: 20px;
        overflow: auto;
        .content{
            width: 100%;
            height: 100%;
            position: relative;
        }
        .titles{
            padding-inline: 50px;
            position: sticky;
            top: 36px;
            right: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: center;
            gap: 10px;
            background-color: white;
            height: 50px;
            p{
                width: 180px;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                text-decoration: underline;
            }
        }
        .text-box{
            padding-inline: 50px;
            margin-top: 20px;
            .info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                background-color: var(--color-light);
                margin-block: 10px;
                padding-block: 10px;
                border-radius: 10px;
                min-height: 70px;
                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    text-align: center;
                    width: 180px;
                }
            }
        }
        .btns{
            position: sticky;
            display: flex;
            align-items: center;
            bottom: 0;
            margin-top: 25px;
            width: 100%;
            padding-inline: 50px;
            justify-content: center;
            background-color: white;
            height: 80px;
            button{
                margin-right: 10px;
                width: 100px;
            }
        }
    }

`
    
const DevamliAraclarIsListelemeModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const {devamliAraclarIsListesiListeleme} = useSelector((state) => state.jobList)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle isDiffPage title="İş Listesi" />
            <div className="content">
                <div className="titles">
                    <p>Yayın Tarihi</p>
                    <p>Araç Konum</p>
                    <p>Gidilebilecek İl</p>
                    <p>Gidilebilecek Bölge</p>
                    <p>Yük Nereden</p>
                    <p>Yük Nereye</p>
                    <p>Yük Tipi</p>
                </div>
                <div className="text-box">
                    {devamliAraclarIsListesiListeleme?.map((item)=>(
                        <div className="info">
                            <p>{moment(item?.createdDate).format('lll')}</p>
                            <p>{item?.vehicleCurrentLocation}</p>
                            <p>{item?.gunlukAracListesiCityCanGos?.map((item) => { return <span> {item?.cityCanGo},{" "} </span> })}</p>
                            <p>{item?.gunlukAracListesiRegionCanGos?.map((item) => { return <span> {item.regionCanGo},{" "}</span> })}</p>
                            <p>{item?.load?.senderAdressCity}/{item?.load?.senderAdressTown}</p>
                            <p>{item?.load?.receiverCity}/{item?.load?.receiverAdressTown}</p>
                            <p>{item?.load?.loadType}</p>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="btns">
                <Button handleClick={()=>dispatch(showModal(null))} width="150px" padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
            </div>
            
        </div>
    </Container>
  )
}

export default DevamliAraclarIsListelemeModal